import React, { useState } from "react";
import "./Home.css";
import sadikImage from "../../image/portraitedited1.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Home = () => {
  const [hello, setHello] = useState("Hello.");
  const [work, setWork] = useState("I am");
  const [sadik, setSadik] = useState("Sadik");

  const change = () => {
    let newHello = hello;
    newHello === "Hello." ? setHello("About") : setHello("Hello.");
    let newWork = work;
    newWork === "I am" ? setWork("Work") : setWork("I am");
    let newSadik = sadik;
    newSadik === "Sadik" ? setSadik("Contact") : setSadik("Sadik");
  };

  return (
    <section className="home" onClick={change}>
      <div className="container">
        <motion.div className="text">
          <Link to="/about">
            <motion.h2
              transition={{ duration: 0.1 }}
              animate={{ y: 0, opacity: 1 }}
              initial={{ y: 100, opacity: 0 }}
              className="hello"
              onMouseEnter={() => setHello("About")}
              onMouseLeave={() => setHello("Hello.")}
            >
              {hello}
            </motion.h2>
          </Link>
          <Link to="/work">
            <motion.h2
              transition={{ duration: 0.1, delay: 0.1 }}
              animate={{ y: 0, opacity: 1 }}
              initial={{ y: 100, opacity: 0 }}
              className="work"
              onMouseEnter={() => setWork("Work")}
              onMouseLeave={() => setWork("I am")}
            >
              {work}
            </motion.h2>
          </Link>
          <Link to="/contact">
            <motion.h2
              transition={{ duration: 0.1, delay: 0.2 }}
              animate={{ y: 0, opacity: 1 }}
              initial={{ y: 100, opacity: 0 }}
              className="sadik"
              onMouseEnter={() => setSadik("Contact")}
              onMouseLeave={() => setSadik("Sadik")}
            >
              {sadik}
            </motion.h2>
          </Link>
        </motion.div>

        <motion.div
          transition={{ duration: 0.3 }}
          animate={{ scale: 1, opacity: 1 }}
          initial={{ scale: 1.1, opacity: 0 }}
          className="image"
        >
          <img src={sadikImage} alt="portrait" />
        </motion.div>
      </div>

      <div className="tap">
        <p>Tap anywhere</p>
      </div>
    </section>
  );
};

export default Home;
